import { Injectable, EventEmitter } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage: Storage;

  public readonly onAvailable: EventEmitter<void>;

  constructor(private storageProvider: Storage) {
    this.onAvailable = new EventEmitter<void>();
  }

  public async init(): Promise<void> {
    this.storage = await this.storageProvider.create();
    this.onAvailable.emit();
  }

  public get(key: string): Promise<any> {
    return this.storage?.get(key);
  }

  public set(key: string, value: any): Promise<any> {
    return this.storage?.set(key, value);
  }

  public remove(key: string): Promise<any> {
    return this.storage?.remove(key);
  }

  public clear(ignored?: string[]): void {
    this.storage.keys().then((keys: string[]) => {
      const remove = keys.filter((key: string) => (ignored || []).filter((item: string) => item === key).length === 0);
      remove.forEach((key: string) => this.storage.remove(key));
    });
  }
}
